function testPlatform(platform) {
    return typeof window !== 'undefined' && window.navigator != null
        ? platform.test(window.navigator.platform)
        : false;
}
export const getKeyboardUtils = () => {
    const isMac = testPlatform(/^Mac/);
    return {
        isCtrlKeyPressed: (event) => isMac ? event.metaKey : event.ctrlKey,
    };
};
export const { isCtrlKeyPressed } = getKeyboardUtils();
//# sourceMappingURL=keyboard.js.map